import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';                   /* Added Line */
import { Button } from "react-bootstrap";

export default function DemandStates() {
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */

  const validationSchema = yup.object({
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepDurumName: values.talepDurumName,
      talepDurumNameTr: values.talepDurumNameTr,
      talepDurumNameEn: values.talepDurumNameEn,
      id: values.id,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      talepDurumName: data.talepDurumName,
      talepDurumNameTr: data.talepDurumNameTr,
      talepDurumNameEn: data.talepDurumNameEn,
      id: data.id,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("pageTitleofDemandCreate.talepDurum")}
            hideNewAddButton
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="talep-durum/create"
              fetchPointUrl="talep-durum/find"
              editPointUrl="talep-durum/update"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="talepDurumNameTr"
                label={t("demandStates.talepDurumuTr")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="talepDurumNameEn"
                label={t("demandStates.talepDurumuEn")}
                colNumber="12"
                component={TextInput}
                onlyEnglish={true}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="talep-durumları"
            endpoint="talep-durum/list"
            keyField="id"
            refreshList={refreshList}
            hideSelection= {true}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header"
              },
              {
                dataField: "talepDurumNameTr",
                text: `${t("demandList.talepDurumuTr")}`,
                sort: true,
              },{
                dataField: "talepDurumNameEn",
                text: `${t("demandList.talepDurumuEn")}`,
                sort: true,
              },
              {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
              sort: false,
            },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                /* requestTo(ABT.DELETE, "talep-durum/delete"), */
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
